import { useLayoutEffect, useState } from "react";
import WorldMpProvider from "@/core/data-provider/data-mp/world/world-mp-provider";
import dateTimeFromUnix from "@/core/helpers/dateTimeFromUnix";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export default function useGetServerDateAndTime(shouldFetch = false) {
  const [serverTime, setServerTime] = useState(null);

  useLayoutEffect(() => {
    if (!shouldFetch) return;

    const fetchTime = async () => {
      try {
        const response = await WorldMpProvider.getWorldTime();
        if (response instanceof RpcMpProviderSuccessResponse) {
          const serverData = response.data.server;
          const serverTimeZone = serverData.timezone;

          const responseObj = dateTimeFromUnix(serverData.timestamp, serverTimeZone);
          const resDay = responseObj.day.toString();
          const resMonth = responseObj.month.toString();

          const formattedResponse = {
            ...responseObj,
            dayStr: resDay.length > 1 ? resDay : `0${resDay}`,
            monthStr: resMonth.length > 1 ? resMonth : `0${resMonth}`,
          };

          setServerTime(formattedResponse);
        } else {
          console.error("Failed to fetch useGetServerDate");
        }
      } catch (e) {
        console.error("Failed to fetch useGetServerDate:", e);
      }
    };

    fetchTime();
  }, [shouldFetch]);

  return serverTime;
}
